import { createActions } from 'redux-actions'

export const {
  getCompanyStatusStatisticsRequest,
  getCompanyStatusStatisticsSucceed,
  getCompanyListRequest,
  getCompanyListSucceed,
  getCompanyDetailRequest,
  getCompanyDetailSucceed,
  createCompanyRequest,
  createCompanySucceed,
  updateCompanyRequest,
  updateCompanySucceed,
  updateCompanyStatusRequest,
  updateCompanyStatusSucceed,
  requestFailure
} = createActions(
  {
    GET_COMPANY_STATUS_STATISTICS_REQUEST: undefined,
    GET_COMPANY_STATUS_STATISTICS_SUCCEED: (companyStatistics) =>
      companyStatistics,
    GET_COMPANY_LIST_REQUEST: ({ page, limit, q, sortBy, sortDirection }) => ({
      page,
      limit,
      q,
      sortBy,
      sortDirection
    }),
    GET_COMPANY_LIST_SUCCEED: (companyList) => companyList,
    GET_COMPANY_DETAIL_REQUEST: (companyId) => companyId,
    GET_COMPANY_DETAIL_SUCCEED: (companyDetail) => companyDetail,
    CREATE_COMPANY_REQUEST: (companyDetail) => companyDetail,
    CREATE_COMPANY_SUCCEED: (companyDetail) => companyDetail,
    UPDATE_COMPANY_REQUEST: ({ companyId, companyDetail }) => ({
      companyId,
      companyDetail
    }),
    UPDATE_COMPANY_SUCCEED: (companyDetail) => companyDetail,
    UPDATE_COMPANY_STATUS_REQUEST: ({ companyId, action }) => ({
      companyId,
      action
    }),
    UPDATE_COMPANY_STATUS_SUCCEED: (companyDetail) => companyDetail,
    REQUEST_FAILURE: (err) => err
  },
  { prefix: 'COMPANY' }
)
